import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from 'react-redux';
import { uploadFacturePrestataireAction, getUploadedFacturesPrestataireAction, startLoader } from "../../../store/actions/FacturationAction";
import { currentUser } from "../../../store/selectors/CurrentUserSelector";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tooltip } from "primereact/tooltip";
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import { DataTableBase } from "../DataTables/DataTableBase";
import{withRouter} from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';
import { ProgressBar } from 'primereact/progressbar';
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { ProgressSpinner } from 'primereact/progressspinner';
import './FacturesPrestataireList.css';


export const FacturesPrestataireList = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const toast = useRef(null);

    const [uploadFilters, setUploadFilters] = useState(null);
    const [globalUploadFilterValue, setGlobalUploadFilterValue] = useState('');
    const [addCard, setAddCard] = useState(false);
    const [progress, setProgress] = useState(0);

    const [totalSize, setTotalSize] = useState(0);
    const fileUploadRef = useRef(null);

    const initUploadFilters = () => {
        setUploadFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            factureURL: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            providerName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            dateFacturation: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
            status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalUploadFilterValue("");
    };

    const renderUploadHeader = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash"  label={t('common.reinit')} outlined onClick={clearUploadFilter} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalUploadFilterValue} onChange={onGlobalUploadFilterChange}  placeholder={t('common.search')} />
                </span>
            </div>
        );
    };


    const clearUploadFilter = () => {
        initUploadFilters();
    };


    const onGlobalUploadFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...uploadFilters };

        _filters['global'].value = value;

        setUploadFilters(_filters);
        setGlobalUploadFilterValue(value);
    };

    const setUploadColumns = () => {
        return [
            {name: 'factureURL', headerName: 'URL de la facture', style: { minWidth: '6rem' },
                bodyTemplate: (rowData) => (
                    <Button
                        label="Télécharger"
                        icon="pi pi-download"
                        className="p-button-success"
                        onClick={() => window.open(rowData.factureURL, '_blank')}
                    />
                )
            },
            {name: 'createdAt', filterField: 'dateFacture', dataType: 'date', headerName: 'Uploadé le', filterPlaceholder: 'Filtrer par date', style: { minWidth: '6rem', fontSize: '14px' }, filter: true, bodyTemplate: dateFacturationUploadBodyTemplate, filterElement: dateFilterUploadTemplate},
            {name: 'status', headerName: 'Statut', filterPlaceholder: 'Filtrer par statut', style: { minWidth: '12rem', fontSize: '14px' }, filter: true, bodyTemplate: null},
        ]
    };

    const dateFilterUploadTemplate = (options) => {
        return <Calendar value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} dateFormat="dd/mm/yy" placeholder="dd/mm/yyyy" mask="99/99/9999" />;
    };

    const dateFacturationUploadBodyTemplate = (rowData) => {
        return formatDate(rowData.createdAt);
    };

    const formatDate = (value) => {
        return value.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

    const onTemplateSelect = (e) => {
        let _totalSize = totalSize;
        let files = e.files;

        Object.keys(files).forEach((key) => {
            _totalSize += files[key].size || 0;
        });

        setTotalSize(_totalSize);
    };

    const onTemplateUpload = (e) => {
        let _totalSize = 0;

        e.files.forEach((file) => {
            _totalSize += file.size || 0;
        });

        setTotalSize(_totalSize);
        console.log("Files uploaded", e.files);
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
    };

    const onTemplateRemove = (file, callback) => {
        setTotalSize(totalSize - file.size);
        callback();
    };

    const onTemplateClear = () => {
        setTotalSize(0);
    };

    const headerTemplate = (options) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize / 500000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';

        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {uploadButton}
                {cancelButton}
                <div className="flex align-items-center gap-3 ml-auto">
                    <span>{formatedValue} / 50 MB</span>
                    <ProgressBar value={value} showValue={false} style={{ width: '10rem', height: '12px' }}></ProgressBar>
                </div>
            </div>
        );
    };

    const itemTemplate = (file, props) => {
        return (
            <div className="flex align-items-center flex-wrap">
                <div className="flex align-items-center" style={{ width: '60%' }}>
                    {/*<img alt={file.name} role="presentation" src={file.objectURL} width={100} />*/}
                    <i className="pi pi-file-pdf" style={{ fontSize: '2rem', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                    <span className="flex flex-column text-left ml-3">
                        {file.name}
                        <small>{new Date().toLocaleDateString()}</small>
                    </span>
                </div>
                <Tag value={props.formatSize} severity="warning" className="px-3 py-2" />
                <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
            </div>
        );
    };

    const emptyTemplate = () => {
        return (
            <div className="flex align-items-center flex-column">
                <i className="pi pi-image mt-3 p-5" style={{ fontSize: '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)' }}></i>
                <span style={{ fontSize: '1.2em', color: 'var(--text-color-secondary)' }} className="my-5">
                    Glisser les fichiers ici pour les charger
                </span>
            </div>
        );
    };


    const chooseOptions = { icon: 'pi pi-fw pi-images', iconOnly: true, className: 'custom-choose-btn p-button-rounded p-button-outlined' };
    const uploadOptions = { icon: 'pi pi-fw pi-cloud-upload', iconOnly: true, className: 'custom-upload-btn p-button-success p-button-rounded p-button-outlined' };
    const cancelOptions = { icon: 'pi pi-fw pi-times', iconOnly: true, className: 'custom-cancel-btn p-button-danger p-button-rounded p-button-outlined' };

    const customUploadHandler = (e) => {
        console.log("Files uploaded", e.files);
        dispatch(startLoader());
        dispatch(uploadFacturePrestataireAction(props.currentUser.providerId, props.currentUser.provider.providerName, e.files));

        let uploadProgress = 0;
        const interval = setInterval(() => {
            uploadProgress += 10;
            setProgress(uploadProgress);

            if (uploadProgress >= 100) {
                clearInterval(interval);
                e.options.onUploadComplete();
                setProgress(0);
            }
        }, 3000);
    }
    
    useEffect(() => {
        if(!props.showLoading){
            setAddCard(false);
        }
    }, [props.showLoading]);

    useEffect(() => {
        dispatch(startLoader());
        console.log(props.currentUser);
        dispatch(getUploadedFacturesPrestataireAction(props.currentUser.providerId));
        
    }, []);

    return (
        <>
            <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
                <div className="mr-auto d-none d-lg-block">
                    <Link
                        to="#"
                        className="btn btn-primary btn-rounded"
                        onClick={() => setAddCard(true)}
                    >
                     Uploader des factures
                    </Link>
                </div>
            </div>
            <Modal className="modal fade" size="lg" show={addCard} onHide={setAddCard} >
                <div className="">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Charger les factures</h4>
                        </div>
                        <div className='card-body'>
                            <div>
                                <Toast ref={toast}></Toast>

                                {props.showLoading && (
                                    <div className="loader-container">
                                        <ProgressSpinner style={{ width: '50px', height: '50px' }} />
                                        <p>Uploading...</p>
                                    </div>
                                )}

                                <Tooltip target=".custom-choose-btn" content="Choose" position="bottom" />
                                <Tooltip target=".custom-upload-btn" content="Upload" position="bottom" />
                                <Tooltip target=".custom-cancel-btn" content="Clear" position="bottom" />

                                <FileUpload ref={fileUploadRef} name="demo[]" customUpload uploadHandler={customUploadHandler} multiple accept=".pdf" maxFileSize={50000000}
                                    onUpload={onTemplateUpload} onSelect={onTemplateSelect} onError={onTemplateClear} onClear={onTemplateClear}
                                    headerTemplate={headerTemplate} itemTemplate={itemTemplate} emptyTemplate={emptyTemplate}
                                    chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} disabled={props.showLoading}
                                    progressBarTemplate={(options) => (
                                        <div
                                            style={{
                                                height: '8px',
                                                width: `${progress}%`,
                                                backgroundColor: '#007ad9',
                                                borderRadius: '4px',
                                                transition: 'width 0.2s ease',
                                            }}
                                        />
                                    )} />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <div className='custom-tab-1'>
                <DataTableBase 
                    data={props.uploadedFacturesPrestataires.map(facture => {
                        return {
                            ...facture,
                            createdAt: new Date(facture.createdAt),
                            status: t(`statuses.${facture.status}`) || facture.status,
                    }})}
                    emptyMessage={t('facturation.no-bill')} 
                    filters={uploadFilters}
                    globalFiltersFields={['factureURL', 'providerName', 'providerId', 'status', 'createdAt']}
                    header={renderUploadHeader()}
                    columns={setUploadColumns()}
                    rows={10} 
                    loading={props.showLoading}
                    size={'small'}
                    exportFilename={"factures-uploadees"}
                    exportColumns={[
                        {  title: 'Id Prestataire', dataKey: 'providerId' },
                        { title: 'Nom prestataire', dataKey: 'providerName' },
                        {  title: 'Url Facture', dataKey: 'factureURL' },
                        {  title: 'Statut', dataKey: 'status' },
                        { title: 'Créé le', dataKey: 'createdAt' },
                    ]}
                    showExport={true}
                />
            </div>
        </>
    )
};

const mapStateToProps = (state) => {
    return {
        uploadedFacturesPrestataires: state.facturation.uploadedFacturesPrestataires,
        showLoading: state.facturation.showLoading,
        currentUser: currentUser(state)
    };
};

export default withRouter(connect(mapStateToProps)(FacturesPrestataireList));
